const revealSelector = '[data-brapp-reveal]';
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function initBrappVideos(root = document) {
  root.querySelectorAll('.brapp-autoplay-video').forEach((video) => {
    if (reducedMotion) {
      video.removeAttribute('autoplay');
      video.pause();
      return;
    }

    const container = video.closest('[data-brapp-video-start]');
    const startPercent = Number(container?.dataset.brappVideoStart || 0);
    if (!startPercent || video.dataset.brappSegmentReady) return;

    video.dataset.brappSegmentReady = 'true';

    const setStart = () => {
      const startTime = video.duration * (startPercent / 100);
      if (!Number.isFinite(startTime)) return;
      video.currentTime = startTime;
    };

    if (video.readyState >= 1) {
      setStart();
    } else {
      video.addEventListener('loadedmetadata', setStart, { once: true });
    }

    video.addEventListener('timeupdate', () => {
      if (video.duration - video.currentTime > 0.25) return;
      setStart();
      video.play().catch(() => {});
    });
  });
}

function revealAll(root = document) {
  root.querySelectorAll(revealSelector).forEach((element) => {
    element.classList.add('is-visible');
  });
}

function initBrappReveals(root = document) {
  const elements = [...root.querySelectorAll(revealSelector)].filter(
    (element) => !element.dataset.brappRevealObserved
  );

  if (!elements.length) return;

  document.documentElement.classList.add('brapp-reveal-ready');

  if (reducedMotion || !('IntersectionObserver' in window)) {
    elements.forEach((element) => {
      element.dataset.brappRevealObserved = 'true';
    });
    revealAll(root);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.12,
    }
  );

  elements.forEach((element) => {
    element.dataset.brappRevealObserved = 'true';
    observer.observe(element);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      initBrappVideos();
      initBrappReveals();
    },
    { once: true }
  );
} else {
  initBrappVideos();
  initBrappReveals();
}

document.addEventListener('shopify:section:load', (event) => {
  initBrappVideos(event.target);
  initBrappReveals(event.target);
});
